const ProductTypes = {
  instantCredit: 'instant-credit',
  instantCreditV2: 'instant-credit-v2',
  loc: 'loc',
  // altl: Amortization Long Term Loans
  instalmentLoan: 'altl',
};

export default ProductTypes;
